import { CalendarOutlined, TableOutlined, SearchOutlined, CalculatorOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { t } from "i18next";
import { useSearch } from "../../../context/SearchContext";

const NAV_HEIGHT = 60;

/* Bar KOYU: zemin marka slate'i (header ile aynı) → uygulama üstten ve alttan aynı renkle
   çerçevelenir. Renkler bu zemine göre kurulur; beyaz bardaki slate ikonlar burada kaybolurdu.
   Ayırıcı çizgi yok: koyu zemin sayfadan zaten ayrılıyor, gölge yeterli. */
const BAR_BG = 'var(--brand)';

const ACTIVE = 'var(--on-brand)';          // seçili sekme: tam beyaz
const INACTIVE = 'var(--on-brand-muted)';  // pasif sekme: beyazın %62'si

// Pill'in iki yarısı da koyu zeminde patlamalı: arama birincil eylem → amber imza,
// teklif ikincil → beyaz kutu + slate ikon.
const SEARCH_BG = 'var(--accent)';
const SEARCH_FG = 'var(--on-brand)';
const QUOTE_BG = 'var(--surface)';
const QUOTE_FG = 'var(--brand)';

// Pill barın İÇİNDE durur (eskiden marginTop:-20 ile üstüne taşıyordu).
const PILL_HEIGHT = 44;

function NavItem({ icon, label, active, onClick }) {
    return (
        <div
            onClick={onClick}
            style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                color: active ? ACTIVE : INACTIVE,
                fontWeight: active ? 600 : 400,
                cursor: 'pointer',
                padding: '6px 4px',
                userSelect: 'none',
                WebkitTapHighlightColor: 'transparent',
            }}
        >
            <span style={{ fontSize: 20, lineHeight: 1 }}>{icon}</span>
            <span style={{ fontSize: 11, lineHeight: 1.2 }}>{label}</span>
        </div>
    );
}

function MergedFabHalf({ icon, bg, fg, ariaLabel, onClick, position }) {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-label={ariaLabel}
            style={{
                width: 54,
                height: PILL_HEIGHT,
                border: 'none',
                background: bg,
                color: fg,
                fontSize: 19,
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                WebkitTapHighlightColor: 'transparent',
                transition: 'filter 120ms ease',
                padding: 0,
                // Hangi yarımsa o tarafa yuvarlatılır (tek buton kalırsa iki taraf da yuvarlak)
                borderTopLeftRadius: position === 'right' ? 0 : PILL_HEIGHT / 2,
                borderBottomLeftRadius: position === 'right' ? 0 : PILL_HEIGHT / 2,
                borderTopRightRadius: position === 'left' ? 0 : PILL_HEIGHT / 2,
                borderBottomRightRadius: position === 'left' ? 0 : PILL_HEIGHT / 2,
                // İki yarım arasında ince ayırıcı (yarımlar açık renkli → koyu dikiş)
                borderLeft: position === 'right' ? '1px solid rgba(44, 62, 80, 0.20)' : undefined,
            }}
            onTouchStart={(e) => { e.currentTarget.style.filter = 'brightness(0.9)'; }}
            onTouchEnd={(e) => { e.currentTarget.style.filter = ''; }}
        >
            {icon}
        </button>
    );
}

export default function BottomNav({ onOpenQuote }) {
    const history = useHistory();
    const { openSearch } = useSearch();
    const path = window.location.pathname;

    const isCalendar = path.includes('/appointments/calendar');
    const isAppointments = path.includes('/appointments/grid') || /\/appointments\/\d+/.test(path);

    return (
        <nav
            style={{
                position: 'fixed',
                left: 0,
                right: 0,
                bottom: 0,
                height: NAV_HEIGHT,
                backgroundColor: BAR_BG,
                boxShadow: '0 -2px 12px rgba(44, 62, 80, 0.28)',
                display: 'flex',
                alignItems: 'stretch',
                zIndex: 99,
                paddingBottom: 'env(safe-area-inset-bottom, 0px)',
            }}
        >
            <NavItem
                icon={<CalendarOutlined />}
                label={t('Calendar')}
                active={isCalendar}
                onClick={() => history.push('/app/appointments/calendar')}
            />
            {/* Orta: Arama + Teklif, tek pill. Barın içinde ve dikeyde ortalı durur. */}
            <div style={{
                flex: 1,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}>
                <div style={{
                    display: 'flex',
                    borderRadius: PILL_HEIGHT / 2,
                    overflow: 'hidden',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.28)',
                }}>
                    {/* Teklif yarısı VIEW_PRICE iznine bağlı; yoksa pill tek butona düşer. */}
                    {onOpenQuote && (
                        <MergedFabHalf
                            icon={<CalculatorOutlined />}
                            bg={QUOTE_BG}
                            fg={QUOTE_FG}
                            ariaLabel={t('Price Quote')}
                            onClick={onOpenQuote}
                            position="left"
                        />
                    )}
                    <MergedFabHalf
                        icon={<SearchOutlined />}
                        bg={SEARCH_BG}
                        fg={SEARCH_FG}
                        ariaLabel={t('Search')}
                        onClick={openSearch}
                        position={onOpenQuote ? "right" : undefined}
                    />
                </div>
            </div>
            <NavItem
                icon={<TableOutlined />}
                label={t('Appointments')}
                active={isAppointments}
                onClick={() => history.push('/app/appointments/grid')}
            />
        </nav>
    );
}

export { NAV_HEIGHT as BOTTOM_NAV_HEIGHT };
